import styled from 'styled-components';
import { unthemed } from 'tokens';

export const Base = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	background: #000;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	min-height: 0;
	max-width: 100%;
`;

export const VideoWrapper = styled.div`
	position: relative;
	flex: 1;
	background: ${unthemed.gray[1000]};
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Square = styled.div`
	flex: 1;
	background: #ff00ff;
`;

export const Loading = styled.div`
	width: 100%;
	height: auto;
	aspect-ratio: 16/9;
	max-height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: ${({ theme }) => theme.gray[100]};
	color: white;
	text-align: center;
	padding: 20px;
`;

export const LoadingContainer = styled.div`
	position: absolute;
	height: 300px;
	width: 50%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
`;

export const LoaderWrapper = styled.div`
	width: 32px;
	height: 32px;
`;

export const LoadingText = styled.div`
	font-weight: 400;
	line-height: 1.5;
	font-size: 20px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const ControlsBar = styled.div`
	background: #1a1a1a;
	padding: 12px 16px;
	display: flex;
	align-items: center;
	gap: 12px;
	border-radius: 0 0 8px 8px;
	border-top: 1px solid #333;
	flex-shrink: 0;
	min-height: 42px;
`;

export const PlayPauseButton = styled.button`
	// layout
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;

	// styles
	background: ${unthemed.green[200]};
	&:hover {
		background: ${unthemed.green[400]};
	}
	border: none;
	border-radius: 999px;
	cursor: pointer;
`;

export const TimelineContainer = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
`;

export const Timeline = styled.input<{ value?: number; max?: number }>`
	width: 100%;
	height: 4px;
	background: ${({ value = 0, max = 1 }) => `
		linear-gradient(
			to right,
			${unthemed.green[200]} 0%,
			${unthemed.green[200]} ${(value / max) * 100}%,
			${unthemed.gray[400]} ${(value / max) * 100}%,
			${unthemed.gray[400]} 100%
		)
	`};
	border-radius: 2px;
	outline: none;
	appearance: none;
	cursor: pointer;

	&::-webkit-slider-thumb {
		appearance: none;
		width: 12px;
		height: 12px;
		background: ${unthemed.green[200]};
		border-radius: 50%;
		cursor: pointer;
	}

	&::-moz-range-thumb {
		width: 12px;
		height: 12px;
		background: ${unthemed.green[200]};
		border-radius: 50%;
		border: none;
		cursor: pointer;
	}
`;

export const TimeDisplay = styled.div`
	color: white;
	font-size: 12px;
	font-weight: 500;
	min-width: 80px;
	text-align: center;
`;

export const VolumeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	position: relative;
`;

export const VolumeIcon = styled.div`
	margin-top: 4px;
	padding-right: 4px;
	cursor: pointer;
`;

export const VolumeSliderContainer = styled.div`
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%);
	background: ${unthemed.gray[1000]};
	padding: 12px 8px;
	border-radius: 8px;
	border: 1px solid #333;
	margin-bottom: 8px;
	z-index: 10;
`;

export const VolumeSlider = styled.input`
	width: 4px;
	height: 80px;
	background: ${unthemed.gray[500]};
	border-radius: 2px;
	outline: none;
	cursor: pointer;
	appearance: none;
	writing-mode: bt-lr;
	-webkit-appearance: slider-vertical;

	&::-webkit-slider-thumb {
		appearance: none;
		width: 10px;
		height: 10px;
		background: ${unthemed.gray[500]};
		border-radius: 50%;
		cursor: pointer;
	}

	&::-moz-range-thumb {
		width: 10px;
		height: 10px;
		background: ${unthemed.gray[0]};
		border-radius: 50%;
		cursor: pointer;
		border: none;
	}

	&:hover {
		background: #ff0000;
	}
`;

export const FullscreenButton = styled.button`
	// layout
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;

	// styles
	background: transparent;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background: ${unthemed.gray[700]};
	}
`;
